import { create } from 'zustand'

interface BearState {
  isShiftDown: boolean
}

export const useServiceState = create<BearState>()(set => ({
  isShiftDown: false,
}))
